const btnNewActionPost = {
  text: 'Enviar'
};

export default btnNewActionPost;
